import { SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";

// Percorsi che NON hanno versione multilingua (auth/admin/garanzie).
const NON_LOCALIZED_PREFIXES = ["/admin", "/area-clienti", "/assistenza", "/garanzia", "/bozza-schede", "/pannelli-fotovoltaici-italiani", "/fotovoltaico", "/fotovoltaico-tetto", "/produzione-di-pannelli-fotovoltaici-made-in-italy"];

export function isNonLocalized(pathname) {
  return NON_LOCALIZED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

// Ricava la lingua attiva dal primo segmento del path.
export function langFromPath(pathname) {
  const seg = (pathname || "/").split("/")[1];
  return SUPPORTED_LANGS.includes(seg) && seg !== DEFAULT_LANG ? seg : DEFAULT_LANG;
}

// Rimuove l'eventuale prefisso lingua, restituendo sempre un path che inizia con "/".
export function stripLang(pathname) {
  const seg = (pathname || "/").split("/")[1];
  if (SUPPORTED_LANGS.includes(seg) && seg !== DEFAULT_LANG) {
    const rest = pathname.slice(seg.length + 1);
    return rest || "/";
  }
  return pathname || "/";
}

// Costruisce il path localizzato per la lingua richiesta.
export function localizePath(pathname, lang) {
  const base = stripLang(pathname);
  // Le pagine non localizzate (auth/admin/garanzie) restano senza prefisso lingua
  // per evitare rotte inesistenti (es. /en/assistenza/garanzia → 404).
  if (isNonLocalized(base)) return base;
  if (lang === DEFAULT_LANG) return base;
  return "/" + lang + (base === "/" ? "" : base);
}
